import * as React from "react";

function SvgComponent(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.001 3.331c-2.466 0-4.543 1.212-6.25 3.204a13.941 13.941 0 00-1.51 2.135c-.252.44-.405.78-.495.99a.882.882 0 000 .676c.09.21.243.55.494.99.416.727.927 1.455 1.511 2.135 1.707 1.992 3.784 3.204 6.25 3.204s4.543-1.212 6.25-3.204a13.943 13.943 0 001.51-2.135c.252-.44.405-.78.495-.99a.882.882 0 000-.676c-.09-.21-.243-.55-.495-.99a13.937 13.937 0 00-1.51-2.135c-1.707-1.992-3.784-3.204-6.25-3.204zm0 1.667c1.91 0 3.582.976 5 2.63.51.595.936 1.235 1.302 1.875.129.226.185.343.26.495-.075.153-.131.27-.26.495-.366.64-.792 1.28-1.302 1.875-1.418 1.654-3.09 2.63-5 2.63-1.91 0-3.582-.976-5-2.63a12.14 12.14 0 01-1.303-1.875c-.128-.226-.184-.342-.26-.495.076-.152.132-.269.26-.495.367-.64.793-1.28 1.303-1.875 1.418-1.654 3.09-2.63 5-2.63zm0 1.667a3.333 3.333 0 103.333 3.333.834.834 0 00-1.666 0A1.667 1.667 0 1110 8.331c.204 0 .413.035.6.105a.831.831 0 10.572-1.563A3.298 3.298 0 0010 6.665z"
        fill={props.color ?? "#23262F"}
      />
    </svg>
  );
}

export default SvgComponent;
